export default "__VITE_ASSET__DJK2YUWF__"